import { render, staticRenderFns } from "./ProjectSetting.vue?vue&type=template&id=3685f7d1&"
import script from "./ProjectSetting.vue?vue&type=script&lang=ts&"
export * from "./ProjectSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports